var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageArticleDetail',{attrs:{"article":_vm.article,"header-configuration":_vm.headerConfiguration,"latest-articles":_vm.latestArticles ? _vm.latestArticles.entities : [],"menu-item":_vm.menuItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }